(function () {
    'use strict';

    var TRIGGER_COLORS = {
        transaction_status_changed:         { iconColor: '#8b5cf6', bgColor: '#ede9fe' },
        mandate_status_changed:             { iconColor: '#0891b2', bgColor: '#cffafe' },
        referral_agent_registered:          { iconColor: '#4f46e5', bgColor: '#e0e7ff' },
        referral_commission_status_changed: { iconColor: '#059669', bgColor: '#d1fae5' }
    };

    var ACTION_COLORS = {
        send_email:          { iconColor: '#65a30d', bgColor: '#ecfccb' },
        send_whatsapp:       { iconColor: '#22c55e', bgColor: '#dcfce7' },
        send_wabot:          { iconColor: '#14b8a6', bgColor: '#99f6e4' },
        send_wasapbot:       { iconColor: '#10b981', bgColor: '#a7f3d0' },
        add_to_smsniaga:     { iconColor: '#0891b2', bgColor: '#cffafe' },
        add_to_mailniaga:    { iconColor: '#e11d48', bgColor: '#ffe4e6' },
        add_to_googlesheets: { iconColor: '#ea580c', bgColor: '#ffedd5' },
        webhook:             { iconColor: '#c026d3', bgColor: '#fae8ff' }
    };

    var CONDITION_COLORS = { iconColor: '#d97706', bgColor: '#fef3c7' };
    var DELAY_COLORS     = { iconColor: '#7c3aed', bgColor: '#ddd6fe' };

    var NODE_W = 200;
    var NODE_H = 70;
    var NODE_R = 10;
    var PORT_R = 6;
    var GRID_SPACING = 20;
    var GRID_MAJOR = 100;
    var DOUBLE_CLICK_MS = 300;
    var DRAG_THRESHOLD = 5;
    var PORT_HIT_R = 10;
    var ACTION_BTN_SIZE = 36;
    var ACTION_BTN_GAP = 8;
    var MINIMAP_W = 200;
    var MINIMAP_H = 120;

    function generateId() {
        return 'node_' + Math.random().toString(36).substr(2, 9);
    }

    function clamp(v, min, max) {
        return Math.max(min, Math.min(max, v));
    }

    function hexToRgba(hex, alpha) {
        var r = parseInt(hex.slice(1, 3), 16);
        var g = parseInt(hex.slice(3, 5), 16);
        var b = parseInt(hex.slice(5, 7), 16);
        return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
    }

    function deepClone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }

    function SimpleWorkflowEditor(canvasId, options) {
        options = options || {};

        this.canvasId = canvasId || 'workflowCanvas';
        this.minimapId = options.minimapId || 'workflowMinimap';
        this.containerSelector = options.containerSelector || '#canvas-container';
        this.displayWidth = options.displayWidth || 5000;
        this.displayHeight = options.displayHeight || 3000;
        this.minZoom = options.minZoom || 0.5;
        this.maxZoom = options.maxZoom || 1.0;
        this.maxHistory = options.maxHistory || 50;

        this.onSave = options.onSave || function () {};
        this.onNodeDoubleClick = options.onNodeDoubleClick || function () {};
        this.onSelectTrigger = options.onSelectTrigger || function () {};

        this.nodes = [];
        this.connections = [];
        this.selectedNodeId = null;
        this.hoveredNodeId = null;
        this.hoveredConnectionIndex = -1;

        this.zoom = 1.0;
        this.panX = 0;
        this.panY = 0;

        this.isDraggingNode = false;
        this.isDraggingPort = false;
        this.dragStartX = 0;
        this.dragStartY = 0;
        this.dragNodeOffsetX = 0;
        this.dragNodeOffsetY = 0;
        this.dragNodeId = null;
        this.dragExceededThreshold = false;
        this.dragPortSource = null;
        this.dragPortEndX = 0;
        this.dragPortEndY = 0;

        this.lastClickTime = 0;
        this.lastClickNodeId = null;

        this.history = [];
        this.historyIndex = -1;

        this.animationTime = 0;
        this.isVisible = true;
        this.animFrameId = null;

        this.saveTimer = null;
        this.saveDelay = 500;

        this.canvas = null;
        this.ctx = null;
        this.minimapCanvas = null;
        this.minimapCtx = null;
        this.container = null;
        this.dpr = 1;

        this.tooltipText = '';
        this.tooltipX = 0;
        this.tooltipY = 0;

        this._boundMouseDown = this.onMouseDown.bind(this);
        this._boundMouseMove = this.onMouseMove.bind(this);
        this._boundMouseUp = this.onMouseUp.bind(this);
        this._boundClick = this.onClick.bind(this);
        this._boundKeyDown = this.onKeyDown.bind(this);
        this._boundWheel = this.onWheel.bind(this);
        this._boundMinimapClick = this.onMinimapClick.bind(this);

        this.init();
    }

    SimpleWorkflowEditor.prototype.init = function () {
        this.canvas = document.getElementById(this.canvasId);
        if (!this.canvas) return;

        this.ctx = this.canvas.getContext('2d');
        this.container = document.querySelector(this.containerSelector);
        this.dpr = window.devicePixelRatio || 1;

        this.resizeCanvas();

        this.canvas.addEventListener('mousedown', this._boundMouseDown);
        this.canvas.addEventListener('mousemove', this._boundMouseMove);
        this.canvas.addEventListener('mouseup', this._boundMouseUp);
        this.canvas.addEventListener('click', this._boundClick);
        this.canvas.addEventListener('wheel', this._boundWheel, { passive: false });
        document.addEventListener('keydown', this._boundKeyDown);

        var minimapEl = document.getElementById(this.minimapId);
        if (minimapEl) {
            this.minimapCanvas = minimapEl;
            this.minimapCtx = minimapEl.getContext('2d');
            minimapEl.width = MINIMAP_W * this.dpr;
            minimapEl.height = MINIMAP_H * this.dpr;
            minimapEl.style.width = MINIMAP_W + 'px';
            minimapEl.style.height = MINIMAP_H + 'px';
            minimapEl.addEventListener('click', this._boundMinimapClick);
        }

        var self = this;
        if ('IntersectionObserver' in window) {
            this._observer = new IntersectionObserver(function (entries) {
                self.isVisible = entries[0].isIntersecting;
            }, { threshold: 0.1 });
            this._observer.observe(this.canvas);
        }

        window.addEventListener('resize', function () {
            self.resizeCanvas();
        });

        this.startAnimation();
    };

    SimpleWorkflowEditor.prototype.resizeCanvas = function () {
        if (!this.canvas || !this.container) return;
        var rect = this.container.getBoundingClientRect();
        var w = rect.width || this.displayWidth;
        var h = rect.height || this.displayHeight;
        this.canvas.width = w * this.dpr;
        this.canvas.height = h * this.dpr;
        this.canvas.style.width = w + 'px';
        this.canvas.style.height = h + 'px';
    };

    SimpleWorkflowEditor.prototype.destroy = function () {
        if (this.canvas) {
            this.canvas.removeEventListener('mousedown', this._boundMouseDown);
            this.canvas.removeEventListener('mousemove', this._boundMouseMove);
            this.canvas.removeEventListener('mouseup', this._boundMouseUp);
            this.canvas.removeEventListener('click', this._boundClick);
            this.canvas.removeEventListener('wheel', this._boundWheel);
        }
        document.removeEventListener('keydown', this._boundKeyDown);
        if (this.minimapCanvas) {
            this.minimapCanvas.removeEventListener('click', this._boundMinimapClick);
        }
        if (this._observer) {
            this._observer.disconnect();
        }
        if (this.animFrameId) {
            cancelAnimationFrame(this.animFrameId);
        }
        if (this.saveTimer) {
            clearTimeout(this.saveTimer);
        }
    };

    // =========================================================================
    // Animation loop
    // =========================================================================

    SimpleWorkflowEditor.prototype.startAnimation = function () {
        var self = this;
        var lastTime = 0;

        function loop(timestamp) {
            self.animFrameId = requestAnimationFrame(loop);
            if (!self.isVisible) return;

            var delta = lastTime ? (timestamp - lastTime) / 1000 : 0.016;
            lastTime = timestamp;
            self.animationTime += delta;

            self.render();
        }

        this.animFrameId = requestAnimationFrame(loop);
    };

    // =========================================================================
    // Main render
    // =========================================================================

    SimpleWorkflowEditor.prototype.render = function () {
        var ctx = this.ctx;
        var w = this.canvas.width;
        var h = this.canvas.height;

        ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
        ctx.clearRect(0, 0, w / this.dpr, h / this.dpr);

        ctx.save();
        ctx.translate(this.panX, this.panY);
        ctx.scale(this.zoom, this.zoom);

        this.drawGrid();
        this.drawConnections();
        this.drawFlowDots();
        this.drawNodes();
        this.drawDragPreview();

        ctx.restore();

        this.drawTooltip();
        this.drawMinimap();
    };

    // =========================================================================
    // Grid
    // =========================================================================

    SimpleWorkflowEditor.prototype.drawGrid = function () {
        var ctx = this.ctx;
        var canvasW = this.canvas.width / (this.dpr * this.zoom);
        var canvasH = this.canvas.height / (this.dpr * this.zoom);
        var startX = Math.floor(-this.panX / this.zoom / GRID_SPACING) * GRID_SPACING;
        var startY = Math.floor(-this.panY / this.zoom / GRID_SPACING) * GRID_SPACING;
        var endX = startX + canvasW + GRID_SPACING * 2;
        var endY = startY + canvasH + GRID_SPACING * 2;

        ctx.fillStyle = '#ffffff';
        ctx.fillRect(startX - GRID_SPACING, startY - GRID_SPACING, endX - startX + GRID_SPACING * 2, endY - startY + GRID_SPACING * 2);

        for (var x = startX; x < endX; x += GRID_SPACING) {
            for (var y = startY; y < endY; y += GRID_SPACING) {
                var isMajor = (x % GRID_MAJOR === 0) && (y % GRID_MAJOR === 0);
                ctx.fillStyle = isMajor ? '#9ca3af' : '#d1d5db';
                var r = isMajor ? 1.5 : 1;
                ctx.beginPath();
                ctx.arc(x, y, r, 0, Math.PI * 2);
                ctx.fill();
            }
        }
    };

    // =========================================================================
    // Connections
    // =========================================================================

    SimpleWorkflowEditor.prototype.drawConnections = function () {
        for (var i = 0; i < this.connections.length; i++) {
            var conn = this.connections[i];
            var fromNode = this.getNodeById(conn.from);
            var toNode = this.getNodeById(conn.to);
            if (!fromNode || !toNode) continue;
            var isHovered = (this.hoveredConnectionIndex === i);
            this.drawConnection(fromNode, toNode, isHovered, i);
        }
    };

    SimpleWorkflowEditor.prototype.drawConnection = function (from, to, isHovered, connIndex) {
        var ctx = this.ctx;
        var x1 = from.x + NODE_W;
        var y1 = from.y + NODE_H / 2;
        var x2 = to.x;
        var y2 = to.y + NODE_H / 2;

        var cpOffset = Math.min(Math.abs(x2 - x1) * 0.5, 150);
        var cp1x = x1 + cpOffset;
        var cp1y = y1;
        var cp2x = x2 - cpOffset;
        var cp2y = y2;

        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x2, y2);
        ctx.strokeStyle = isHovered ? '#ef4444' : '#7dd3fc';
        ctx.lineWidth = isHovered ? 3 : 2;
        ctx.stroke();

        this.drawArrowAtT(ctx, x1, y1, cp1x, cp1y, cp2x, cp2y, x2, y2, 0.95, isHovered);

        if (isHovered) {
            this.drawConnectionDeleteButton(ctx, x1, y1, cp1x, cp1y, cp2x, cp2y, x2, y2, connIndex);
        }
    };

    SimpleWorkflowEditor.prototype.drawArrowAtT = function (ctx, x1, y1, cp1x, cp1y, cp2x, cp2y, x2, y2, t, isHovered) {
        var pt = this.bezierPoint(x1, y1, cp1x, cp1y, cp2x, cp2y, x2, y2, t);
        var dt = this.bezierTangent(x1, y1, cp1x, cp1y, cp2x, cp2y, x2, y2, t);
        var angle = Math.atan2(dt.y, dt.x);
        var arrowLen = 10;
        var arrowAngle = Math.PI / 6;

        ctx.beginPath();
        ctx.moveTo(pt.x, pt.y);
        ctx.lineTo(pt.x - arrowLen * Math.cos(angle - arrowAngle), pt.y - arrowLen * Math.sin(angle - arrowAngle));
        ctx.moveTo(pt.x, pt.y);
        ctx.lineTo(pt.x - arrowLen * Math.cos(angle + arrowAngle), pt.y - arrowLen * Math.sin(angle + arrowAngle));
        ctx.strokeStyle = isHovered ? '#ef4444' : '#7dd3fc';
        ctx.lineWidth = isHovered ? 3 : 2;
        ctx.stroke();
    };

    SimpleWorkflowEditor.prototype.drawConnectionDeleteButton = function (ctx, x1, y1, cp1x, cp1y, cp2x, cp2y, x2, y2, connIndex) {
        var mid = this.bezierPoint(x1, y1, cp1x, cp1y, cp2x, cp2y, x2, y2, 0.5);
        var r = 12;

        ctx.beginPath();
        ctx.arc(mid.x, mid.y, r, 0, Math.PI * 2);
        ctx.fillStyle = '#ef4444';
        ctx.fill();
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 2;
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(mid.x - 4, mid.y - 4);
        ctx.lineTo(mid.x + 4, mid.y + 4);
        ctx.moveTo(mid.x + 4, mid.y - 4);
        ctx.lineTo(mid.x - 4, mid.y + 4);
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 2;
        ctx.stroke();

        this.connections[connIndex]._deleteBtnX = mid.x;
        this.connections[connIndex]._deleteBtnY = mid.y;
        this.connections[connIndex]._deleteBtnR = r;
    };

    // =========================================================================
    // Flow dots
    // =========================================================================

    SimpleWorkflowEditor.prototype.drawFlowDots = function () {
        var ctx = this.ctx;
        var t = this.animationTime;

        for (var i = 0; i < this.connections.length; i++) {
            var conn = this.connections[i];
            var fromNode = this.getNodeById(conn.from);
            var toNode = this.getNodeById(conn.to);
            if (!fromNode || !toNode) continue;

            var x1 = fromNode.x + NODE_W;
            var y1 = fromNode.y + NODE_H / 2;
            var x2 = toNode.x;
            var y2 = toNode.y + NODE_H / 2;
            var cpOffset = Math.min(Math.abs(x2 - x1) * 0.5, 150);
            var cp1x = x1 + cpOffset;
            var cp1y = y1;
            var cp2x = x2 - cpOffset;
            var cp2y = y2;

            for (var d = 0; d < 3; d++) {
                var progress = ((t * 0.4 + d / 3) % 1);
                var opacity = Math.sin(progress * Math.PI) * 0.7;
                var pt = this.bezierPoint(x1, y1, cp1x, cp1y, cp2x, cp2y, x2, y2, progress);

                ctx.beginPath();
                ctx.arc(pt.x, pt.y, 3, 0, Math.PI * 2);
                ctx.fillStyle = hexToRgba('#7dd3fc', opacity);
                ctx.fill();
            }
        }
    };

    // =========================================================================
    // Nodes
    // =========================================================================

    SimpleWorkflowEditor.prototype.drawNodes = function () {
        for (var i = 0; i < this.nodes.length; i++) {
            var node = this.nodes[i];
            if (node.type === 'placeholder') {
                this.drawPlaceholder(node);
            } else {
                this.drawNode(node);
            }
            if (node.type !== 'placeholder') {
                this.drawPorts(node);
            }
        }

        if (this.selectedNodeId) {
            var sel = this.getNodeById(this.selectedNodeId);
            if (sel && sel.type !== 'placeholder') {
                this.drawActionButtons(sel);
            }
        }
    };

    SimpleWorkflowEditor.prototype.drawNode = function (node) {
        var ctx = this.ctx;
        var x = node.x;
        var y = node.y;
        var isSelected = (node.id === this.selectedNodeId);
        var isHovered = (node.id === this.hoveredNodeId);
        var colors = this.getNodeColors(node);
        var complete = this.isNodeComplete(node);
        var unconfigured = this.isNodeUnconfigured(node);
        var hasWarning = !complete || unconfigured;

        this.roundRect(ctx, x, y, NODE_W, NODE_H, NODE_R);
        ctx.fillStyle = colors.bgColor;
        ctx.fill();

        if (isSelected) {
            ctx.strokeStyle = '#ef4444';
            ctx.lineWidth = 3;
        } else if (hasWarning) {
            ctx.strokeStyle = '#ef4444';
            ctx.lineWidth = 2;
        } else {
            ctx.strokeStyle = '#e5e7eb';
            ctx.lineWidth = 1.5;
        }
        ctx.stroke();

        if (isHovered && !isSelected) {
            this.roundRect(ctx, x, y, NODE_W, NODE_H, NODE_R);
            ctx.strokeStyle = hexToRgba('#3b82f6', 0.5);
            ctx.lineWidth = 2;
            ctx.stroke();
        }

        var iconX = x + 28;
        var iconY = y + NODE_H / 2;
        this.drawIconShape(ctx, iconX, iconY, node, colors);

        ctx.font = '600 13px -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
        ctx.fillStyle = '#1f2937';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';

        var label = node.label || '';
        var maxLabelW = NODE_W - 68;
        var truncated = this.truncateText(ctx, label, maxLabelW);
        ctx.fillText(truncated, x + 56, y + NODE_H / 2);

        if (hasWarning) {
            this.drawIncompleteBadge(ctx, x + NODE_W - 8, y + 8);
        }
    };

    SimpleWorkflowEditor.prototype.drawIconShape = function (ctx, cx, cy, node, colors) {
        if (node.type === 'trigger') {
            ctx.beginPath();
            ctx.arc(cx, cy, 18, 0, Math.PI * 2);
            ctx.fillStyle = colors.iconColor;
            ctx.fill();

            ctx.save();
            ctx.beginPath();
            ctx.arc(cx, cy, 18, 0, Math.PI * 2);
            ctx.clip();
            var trigType = (node.data && node.data.trigger_type) || '';
            this.drawTriggerIcon(ctx, cx, cy, trigType);
            ctx.restore();
        } else {
            this.roundRect(ctx, cx - 18, cy - 18, 36, 36, 8);
            ctx.fillStyle = colors.iconColor;
            ctx.fill();

            ctx.save();
            this.roundRect(ctx, cx - 18, cy - 18, 36, 36, 8);
            ctx.clip();
            if (node.type === 'action') {
                var actType = (node.data && node.data.action_type) || '';
                this.drawActionIcon(ctx, cx, cy, actType);
            } else if (node.type === 'condition') {
                this.drawConditionIcon(ctx, cx, cy);
            } else if (node.type === 'delay') {
                this.drawDelayIcon(ctx, cx, cy);
            }
            ctx.restore();
        }
    };

    SimpleWorkflowEditor.prototype.drawIncompleteBadge = function (ctx, x, y) {
        ctx.beginPath();
        ctx.arc(x, y, 9, 0, Math.PI * 2);
        ctx.fillStyle = '#ef4444';
        ctx.fill();
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 2;
        ctx.stroke();

        ctx.font = 'bold 11px sans-serif';
        ctx.fillStyle = '#ffffff';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('!', x, y);
    };

    SimpleWorkflowEditor.prototype.drawPlaceholder = function (node) {
        var ctx = this.ctx;
        var x = node.x;
        var y = node.y;

        ctx.setLineDash([6, 4]);
        this.roundRect(ctx, x, y, NODE_W, NODE_H, NODE_R);
        ctx.strokeStyle = '#9ca3af';
        ctx.lineWidth = 2;
        ctx.stroke();
        ctx.setLineDash([]);

        ctx.fillStyle = '#f3f4f6';
        this.roundRect(ctx, x, y, NODE_W, NODE_H, NODE_R);
        ctx.fill();

        var cx = x + NODE_W / 2;
        var cy = y + NODE_H / 2 - 6;
        ctx.beginPath();
        ctx.arc(cx, cy, 14, 0, Math.PI * 2);
        ctx.fillStyle = '#d1d5db';
        ctx.fill();

        ctx.beginPath();
        ctx.moveTo(cx - 6, cy);
        ctx.lineTo(cx + 6, cy);
        ctx.moveTo(cx, cy - 6);
        ctx.lineTo(cx, cy + 6);
        ctx.strokeStyle = '#6b7280';
        ctx.lineWidth = 2;
        ctx.stroke();

        ctx.font = '500 11px -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
        ctx.fillStyle = '#6b7280';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        ctx.fillText('Select an Event', cx, cy + 20);
    };

    // =========================================================================
    // Ports
    // =========================================================================

    SimpleWorkflowEditor.prototype.drawPorts = function (node) {
        var ctx = this.ctx;
        var isFirst = this.nodes.indexOf(node) === 0;

        if (!isFirst) {
            var ix = node.x;
            var iy = node.y + NODE_H / 2;
            ctx.beginPath();
            ctx.arc(ix, iy, PORT_R, 0, Math.PI * 2);
            ctx.fillStyle = '#6366f1';
            ctx.fill();
            ctx.strokeStyle = '#ffffff';
            ctx.lineWidth = 2;
            ctx.stroke();
        }

        var ox = node.x + NODE_W;
        var oy = node.y + NODE_H / 2;
        ctx.beginPath();
        ctx.arc(ox, oy, PORT_R, 0, Math.PI * 2);
        ctx.fillStyle = '#10b981';
        ctx.fill();
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 2;
        ctx.stroke();
    };

    // =========================================================================
    // Action Buttons below selected node
    // =========================================================================

    SimpleWorkflowEditor.prototype.drawActionButtons = function (node) {
        var ctx = this.ctx;
        var totalW = ACTION_BTN_SIZE * 3 + ACTION_BTN_GAP * 2;
        var startX = node.x + (NODE_W - totalW) / 2;
        var y = node.y + NODE_H + 10;
        var btns = [
            { label: 'Configure', color: '#3b82f6', icon: 'gear' },
            { label: 'Clone',     color: '#7c3aed', icon: 'copy' },
            { label: 'Delete',    color: '#ef4444', icon: 'trash' }
        ];

        this._actionButtons = [];

        for (var i = 0; i < btns.length; i++) {
            var bx = startX + i * (ACTION_BTN_SIZE + ACTION_BTN_GAP);
            var by = y;
            var btn = btns[i];

            this.roundRect(ctx, bx, by, ACTION_BTN_SIZE, ACTION_BTN_SIZE, 8);
            ctx.fillStyle = btn.color;
            ctx.fill();

            ctx.fillStyle = '#ffffff';
            this.drawBtnIcon(ctx, bx + ACTION_BTN_SIZE / 2, by + ACTION_BTN_SIZE / 2, btn.icon);

            this._actionButtons.push({
                x: bx, y: by, w: ACTION_BTN_SIZE, h: ACTION_BTN_SIZE,
                action: btn.label.toLowerCase(), nodeId: node.id
            });
        }
    };

    SimpleWorkflowEditor.prototype.drawBtnIcon = function (ctx, cx, cy, icon) {
        ctx.strokeStyle = '#ffffff';
        ctx.fillStyle = '#ffffff';
        ctx.lineWidth = 1.5;

        if (icon === 'gear') {
            ctx.beginPath();
            ctx.arc(cx, cy, 4, 0, Math.PI * 2);
            ctx.stroke();
            for (var a = 0; a < 8; a++) {
                var ang = (a / 8) * Math.PI * 2;
                ctx.beginPath();
                ctx.arc(cx + Math.cos(ang) * 8, cy + Math.sin(ang) * 8, 1.5, 0, Math.PI * 2);
                ctx.fill();
            }
        } else if (icon === 'copy') {
            this.roundRect(ctx, cx - 5, cy - 7, 9, 11, 2);
            ctx.stroke();
            this.roundRect(ctx, cx - 3, cy - 5, 9, 11, 2);
            ctx.stroke();
        } else if (icon === 'trash') {
            ctx.beginPath();
            ctx.moveTo(cx - 6, cy - 6);
            ctx.lineTo(cx + 6, cy - 6);
            ctx.stroke();
            ctx.beginPath();
            ctx.moveTo(cx - 2, cy - 6);
            ctx.lineTo(cx - 1, cy - 9);
            ctx.lineTo(cx + 1, cy - 9);
            ctx.lineTo(cx + 2, cy - 6);
            ctx.stroke();
            this.roundRect(ctx, cx - 5, cy - 6, 10, 14, 2);
            ctx.stroke();
            ctx.beginPath();
            ctx.moveTo(cx - 2, cy - 3);
            ctx.lineTo(cx - 2, cy + 5);
            ctx.moveTo(cx + 2, cy - 3);
            ctx.lineTo(cx + 2, cy + 5);
            ctx.stroke();
        }
    };

    // =========================================================================
    // Drag preview (port connection)
    // =========================================================================

    SimpleWorkflowEditor.prototype.drawDragPreview = function () {
        if (!this.isDraggingPort || !this.dragPortSource) return;

        var ctx = this.ctx;
        var src = this.getNodeById(this.dragPortSource);
        if (!src) return;

        var x1 = src.x + NODE_W;
        var y1 = src.y + NODE_H / 2;
        var x2 = this.dragPortEndX;
        var y2 = this.dragPortEndY;
        var cpOffset = Math.min(Math.abs(x2 - x1) * 0.5, 150);

        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.bezierCurveTo(x1 + cpOffset, y1, x2 - cpOffset, y2, x2, y2);
        ctx.strokeStyle = hexToRgba('#7dd3fc', 0.5);
        ctx.lineWidth = 2;
        ctx.setLineDash([6, 4]);
        ctx.stroke();
        ctx.setLineDash([]);
    };

    // =========================================================================
    // Tooltip
    // =========================================================================

    SimpleWorkflowEditor.prototype.drawTooltip = function () {
        if (!this.tooltipText) return;
        var ctx = this.ctx;
        ctx.font = '12px -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
        var tw = ctx.measureText(this.tooltipText).width + 16;
        var th = 28;
        var tx = this.tooltipX + 12;
        var ty = this.tooltipY - th - 4;

        ctx.fillStyle = 'rgba(31,41,55,0.9)';
        this.roundRect(ctx, tx, ty, tw, th, 6);
        ctx.fill();

        ctx.fillStyle = '#ffffff';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        ctx.fillText(this.tooltipText, tx + 8, ty + th / 2);
    };

    // =========================================================================
    // Minimap
    // =========================================================================

    SimpleWorkflowEditor.prototype.drawMinimap = function () {
        if (!this.minimapCtx) return;

        var mctx = this.minimapCtx;
        mctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
        mctx.clearRect(0, 0, MINIMAP_W, MINIMAP_H);

        mctx.fillStyle = '#f9fafb';
        mctx.fillRect(0, 0, MINIMAP_W, MINIMAP_H);
        mctx.strokeStyle = '#e5e7eb';
        mctx.lineWidth = 1;
        mctx.strokeRect(0, 0, MINIMAP_W, MINIMAP_H);

        if (this.nodes.length === 0) return;

        var bounds = this.getNodesBounds();
        var padding = 40;
        var bw = bounds.maxX - bounds.minX + NODE_W + padding * 2;
        var bh = bounds.maxY - bounds.minY + NODE_H + padding * 2;
        var scale = Math.min(MINIMAP_W / bw, MINIMAP_H / bh, 1);
        var offX = (MINIMAP_W - bw * scale) / 2 - bounds.minX * scale + padding * scale;
        var offY = (MINIMAP_H - bh * scale) / 2 - bounds.minY * scale + padding * scale;

        for (var c = 0; c < this.connections.length; c++) {
            var conn = this.connections[c];
            var fn = this.getNodeById(conn.from);
            var tn = this.getNodeById(conn.to);
            if (!fn || !tn) continue;

            mctx.beginPath();
            mctx.moveTo(fn.x * scale + offX + NODE_W * scale, fn.y * scale + offY + NODE_H * scale / 2);
            mctx.lineTo(tn.x * scale + offX, tn.y * scale + offY + NODE_H * scale / 2);
            mctx.strokeStyle = '#7dd3fc';
            mctx.lineWidth = 1;
            mctx.stroke();
        }

        for (var i = 0; i < this.nodes.length; i++) {
            var node = this.nodes[i];
            var nx = node.x * scale + offX;
            var ny = node.y * scale + offY;
            var nw = NODE_W * scale;
            var nh = NODE_H * scale;
            var colors = this.getNodeColors(node);

            mctx.fillStyle = node.type === 'placeholder' ? '#e5e7eb' : colors.bgColor;
            mctx.fillRect(nx, ny, nw, nh);

            if (node.id === this.selectedNodeId) {
                mctx.strokeStyle = '#ef4444';
                mctx.lineWidth = 2;
                mctx.strokeRect(nx, ny, nw, nh);
            }
        }

        var canvasW = this.canvas.width / (this.dpr * this.zoom);
        var canvasH = this.canvas.height / (this.dpr * this.zoom);
        var vpX = (-this.panX / this.zoom) * scale + offX;
        var vpY = (-this.panY / this.zoom) * scale + offY;
        var vpW = canvasW * scale;
        var vpH = canvasH * scale;

        mctx.strokeStyle = '#3b82f6';
        mctx.lineWidth = 2;
        mctx.strokeRect(vpX, vpY, vpW, vpH);

        this._minimapScale = scale;
        this._minimapOffX = offX;
        this._minimapOffY = offY;
    };

    // =========================================================================
    // Node icon drawing methods
    // =========================================================================

    SimpleWorkflowEditor.prototype.drawTriggerIcon = function (ctx, cx, cy, triggerType) {
        ctx.strokeStyle = '#ffffff';
        ctx.fillStyle = '#ffffff';
        ctx.lineWidth = 1.5;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';

        switch (triggerType) {
            case 'transaction_status_changed':
                // Right arrow (top)
                ctx.beginPath();
                ctx.moveTo(cx - 8, cy - 3);
                ctx.lineTo(cx + 5, cy - 3);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx + 1, cy - 7);
                ctx.lineTo(cx + 5, cy - 3);
                ctx.lineTo(cx + 1, cy + 1);
                ctx.stroke();
                // Left arrow (bottom)
                ctx.beginPath();
                ctx.moveTo(cx + 8, cy + 3);
                ctx.lineTo(cx - 5, cy + 3);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx - 1, cy + 7);
                ctx.lineTo(cx - 5, cy + 3);
                ctx.lineTo(cx - 1, cy - 1);
                ctx.stroke();
                break;

            case 'mandate_status_changed':
                ctx.beginPath();
                ctx.moveTo(cx - 5, cy - 7);
                ctx.lineTo(cx - 5, cy + 7);
                ctx.lineTo(cx + 5, cy + 7);
                ctx.lineTo(cx + 5, cy - 4);
                ctx.lineTo(cx + 2, cy - 7);
                ctx.closePath();
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx - 2, cy + 1);
                ctx.lineTo(cx, cy + 3);
                ctx.lineTo(cx + 4, cy - 2);
                ctx.stroke();
                break;

            case 'referral_agent_registered':
                ctx.beginPath();
                ctx.arc(cx - 2, cy - 3, 3.5, 0, Math.PI * 2);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx - 8, cy + 7);
                ctx.quadraticCurveTo(cx - 2, cy + 1, cx + 4, cy + 7);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx + 5, cy - 3);
                ctx.lineTo(cx + 9, cy - 3);
                ctx.moveTo(cx + 7, cy - 5);
                ctx.lineTo(cx + 7, cy - 1);
                ctx.stroke();
                break;

            case 'referral_commission_status_changed':
                ctx.beginPath();
                ctx.arc(cx, cy, 7, 0, Math.PI * 2);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx - 3, cy);
                ctx.lineTo(cx - 1, cy + 3);
                ctx.lineTo(cx + 4, cy - 3);
                ctx.stroke();
                break;

            default:
                ctx.beginPath();
                ctx.moveTo(cx - 2, cy - 8);
                ctx.lineTo(cx + 3, cy - 1);
                ctx.lineTo(cx - 1, cy - 1);
                ctx.lineTo(cx + 2, cy + 8);
                ctx.lineTo(cx - 3, cy + 1);
                ctx.lineTo(cx + 1, cy + 1);
                ctx.closePath();
                ctx.fill();
                break;
        }
    };

    SimpleWorkflowEditor.prototype.drawActionIcon = function (ctx, cx, cy, actionType) {
        ctx.strokeStyle = '#ffffff';
        ctx.fillStyle = '#ffffff';
        ctx.lineWidth = 1.5;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';

        switch (actionType) {
            case 'send_email':
                ctx.beginPath();
                this.roundRect(ctx, cx - 8, cy - 5, 16, 11, 2);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx - 8, cy - 5);
                ctx.lineTo(cx, cy + 1);
                ctx.lineTo(cx + 8, cy - 5);
                ctx.stroke();
                break;

            case 'send_whatsapp':
                ctx.beginPath();
                ctx.arc(cx, cy - 1, 8, 0, Math.PI * 2);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx - 4, cy + 5);
                ctx.quadraticCurveTo(cx - 8, cy + 9, cx - 6, cy + 7);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx - 4, cy - 2);
                ctx.lineTo(cx - 2, cy + 1);
                ctx.lineTo(cx, cy - 1);
                ctx.lineTo(cx + 2, cy + 1);
                ctx.lineTo(cx + 4, cy - 2);
                ctx.stroke();
                break;

            case 'send_wabot':
                ctx.beginPath();
                ctx.moveTo(cx - 3, cy + 4);
                ctx.lineTo(cx + 7, cy - 4);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx + 7, cy - 4);
                ctx.lineTo(cx + 2, cy - 3);
                ctx.lineTo(cx + 4, cy + 1);
                ctx.closePath();
                ctx.fill();
                ctx.beginPath();
                ctx.moveTo(cx - 7, cy + 6);
                ctx.lineTo(cx - 3, cy + 4);
                ctx.lineTo(cx - 5, cy + 1);
                ctx.stroke();
                break;

            case 'send_wasapbot':
                ctx.beginPath();
                this.roundRect(ctx, cx - 7, cy - 6, 14, 10, 3);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx - 4, cy + 4);
                ctx.lineTo(cx - 7, cy + 7);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx - 2, cy - 1);
                ctx.lineTo(cx + 4, cy - 1);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx + 3, cy - 1);
                ctx.lineTo(cx + 5, cy - 3);
                ctx.lineTo(cx + 5, cy + 1);
                ctx.stroke();
                break;

            case 'add_to_smsniaga':
                ctx.beginPath();
                this.roundRect(ctx, cx - 8, cy - 5, 11, 8, 3);
                ctx.stroke();
                ctx.beginPath();
                this.roundRect(ctx, cx - 3, cy - 2, 11, 8, 3);
                ctx.stroke();
                break;

            case 'add_to_mailniaga':
                ctx.font = 'bold 14px sans-serif';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText('@', cx, cy);
                break;

            case 'add_to_googlesheets':
                ctx.beginPath();
                ctx.moveTo(cx - 6, cy - 7);
                ctx.lineTo(cx - 6, cy + 7);
                ctx.lineTo(cx + 6, cy + 7);
                ctx.lineTo(cx + 6, cy - 4);
                ctx.lineTo(cx + 3, cy - 7);
                ctx.closePath();
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(cx - 3, cy - 2);
                ctx.lineTo(cx + 3, cy - 2);
                ctx.moveTo(cx - 3, cy + 1);
                ctx.lineTo(cx + 3, cy + 1);
                ctx.moveTo(cx - 3, cy + 4);
                ctx.lineTo(cx + 3, cy + 4);
                ctx.stroke();
                break;

            case 'webhook':
                ctx.beginPath();
                ctx.moveTo(cx - 2, cy - 8);
                ctx.lineTo(cx + 3, cy - 1);
                ctx.lineTo(cx - 1, cy - 1);
                ctx.lineTo(cx + 2, cy + 8);
                ctx.lineTo(cx - 3, cy + 1);
                ctx.lineTo(cx + 1, cy + 1);
                ctx.closePath();
                ctx.fill();
                break;

            default:
                ctx.beginPath();
                ctx.arc(cx, cy, 6, 0, Math.PI * 2);
                ctx.stroke();
                break;
        }
    };

    SimpleWorkflowEditor.prototype.drawConditionIcon = function (ctx, cx, cy) {
        ctx.font = 'bold 18px -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
        ctx.fillStyle = '#ffffff';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('?', cx, cy);
    };

    SimpleWorkflowEditor.prototype.drawDelayIcon = function (ctx, cx, cy) {
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 1.5;
        ctx.lineCap = 'round';

        ctx.beginPath();
        ctx.arc(cx, cy, 8, 0, Math.PI * 2);
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(cx, cy - 4);
        ctx.lineTo(cx, cy);
        ctx.lineTo(cx + 3, cy + 3);
        ctx.stroke();
    };

    // =========================================================================
    // Mouse event handlers
    // =========================================================================

    SimpleWorkflowEditor.prototype.onMouseDown = function (e) {
        var pos = this.screenToCanvas(e.offsetX, e.offsetY);
        var x = pos.x;
        var y = pos.y;

        var port = this.getPortAtPoint(x, y, 'output');
        if (port) {
            this.isDraggingPort = true;
            this.dragPortSource = port.id;
            this.dragPortEndX = x;
            this.dragPortEndY = y;
            e.preventDefault();
            return;
        }

        var node = this.getNodeAtPoint(x, y);
        if (node && node.type !== 'placeholder') {
            this.dragNodeId = node.id;
            this.dragStartX = e.offsetX;
            this.dragStartY = e.offsetY;
            this.dragNodeOffsetX = x - node.x;
            this.dragNodeOffsetY = y - node.y;
            this.dragExceededThreshold = false;
            e.preventDefault();
            return;
        }

        if (!node) {
            this._panStartX = e.offsetX;
            this._panStartY = e.offsetY;
            this._panStartPanX = this.panX;
            this._panStartPanY = this.panY;
            this._isPanning = true;
        }
    };

    SimpleWorkflowEditor.prototype.onMouseMove = function (e) {
        var pos = this.screenToCanvas(e.offsetX, e.offsetY);
        var x = pos.x;
        var y = pos.y;

        if (this._isPanning) {
            var dx = e.offsetX - this._panStartX;
            var dy = e.offsetY - this._panStartY;
            this.panX = this._panStartPanX + dx;
            this.panY = this._panStartPanY + dy;
            this.canvas.style.cursor = 'grabbing';
            return;
        }

        if (this.isDraggingPort) {
            this.dragPortEndX = x;
            this.dragPortEndY = y;
            this.canvas.style.cursor = 'crosshair';
            return;
        }

        if (this.dragNodeId) {
            var dx2 = e.offsetX - this.dragStartX;
            var dy2 = e.offsetY - this.dragStartY;
            if (!this.dragExceededThreshold) {
                if (Math.abs(dx2) > DRAG_THRESHOLD || Math.abs(dy2) > DRAG_THRESHOLD) {
                    this.dragExceededThreshold = true;
                    this.isDraggingNode = true;
                    this.pushHistory();
                }
            }
            if (this.isDraggingNode) {
                var node = this.getNodeById(this.dragNodeId);
                if (node) {
                    node.x = x - this.dragNodeOffsetX;
                    node.y = y - this.dragNodeOffsetY;
                }
                this.canvas.style.cursor = 'move';
            }
            return;
        }

        this.tooltipText = '';
        this.hoveredNodeId = null;
        this.hoveredConnectionIndex = -1;

        var hNode = this.getNodeAtPoint(x, y);
        if (hNode) {
            this.hoveredNodeId = hNode.id;
            if (hNode.type !== 'placeholder' && (!this.isNodeComplete(hNode) || this.isNodeUnconfigured(hNode))) {
                this.tooltipText = this.getNodeIncompleteReason(hNode);
                this.tooltipX = e.offsetX;
                this.tooltipY = e.offsetY;
            }
            this.canvas.style.cursor = 'pointer';
            return;
        }

        var port = this.getPortAtPoint(x, y, 'output');
        if (port) {
            this.canvas.style.cursor = 'crosshair';
            return;
        }

        var connIdx = this.getConnectionAtPoint(x, y);
        if (connIdx >= 0) {
            this.hoveredConnectionIndex = connIdx;
            this.canvas.style.cursor = 'pointer';
            return;
        }

        this.canvas.style.cursor = 'default';
    };

    SimpleWorkflowEditor.prototype.onMouseUp = function (e) {
        if (this._isPanning) {
            this._isPanning = false;
            this.canvas.style.cursor = 'default';
            return;
        }

        if (this.isDraggingPort) {
            var pos = this.screenToCanvas(e.offsetX, e.offsetY);
            var target = this.getPortAtPoint(pos.x, pos.y, 'input');
            if (target && target.id !== this.dragPortSource) {
                var exists = this.connections.some(function (c) {
                    return c.from === this.dragPortSource && c.to === target.id;
                }.bind(this));
                if (!exists) {
                    this.pushHistory();
                    this.connections.push({ from: this.dragPortSource, to: target.id });
                    this.save();
                }
            }
            this.isDraggingPort = false;
            this.dragPortSource = null;
            this.canvas.style.cursor = 'default';
            return;
        }

        if (this.isDraggingNode) {
            this.isDraggingNode = false;
            this.dragNodeId = null;
            this.dragExceededThreshold = false;
            this.canvas.style.cursor = 'default';
            this.save();
            return;
        }

        this.dragNodeId = null;
        this.dragExceededThreshold = false;
    };

    SimpleWorkflowEditor.prototype.onClick = function (e) {
        if (this.isDraggingNode || this.isDraggingPort || this._isPanning) return;

        var pos = this.screenToCanvas(e.offsetX, e.offsetY);
        var x = pos.x;
        var y = pos.y;

        if (this.selectedNodeId && this._actionButtons) {
            for (var b = 0; b < this._actionButtons.length; b++) {
                var btn = this._actionButtons[b];
                if (x >= btn.x && x <= btn.x + btn.w && y >= btn.y && y <= btn.y + btn.h) {
                    this.handleActionButton(btn.action, btn.nodeId);
                    return;
                }
            }
        }

        if (this.hoveredConnectionIndex >= 0) {
            var conn = this.connections[this.hoveredConnectionIndex];
            if (conn && conn._deleteBtnX !== undefined) {
                var dbx = conn._deleteBtnX;
                var dby = conn._deleteBtnY;
                var dbr = conn._deleteBtnR || 12;
                var dist = Math.sqrt((x - dbx) * (x - dbx) + (y - dby) * (y - dby));
                if (dist <= dbr) {
                    this.pushHistory();
                    this.connections.splice(this.hoveredConnectionIndex, 1);
                    this.hoveredConnectionIndex = -1;
                    this.saveImmediate();
                    return;
                }
            }
        }

        var node = this.getNodeAtPoint(x, y);
        if (node) {
            if (node.type === 'placeholder') {
                this.onSelectTrigger();
                return;
            }

            var now = Date.now();
            if (this.lastClickNodeId === node.id && (now - this.lastClickTime) < DOUBLE_CLICK_MS) {
                this.onNodeDoubleClick(node);
                this.lastClickTime = 0;
                this.lastClickNodeId = null;
                return;
            }
            this.lastClickTime = now;
            this.lastClickNodeId = node.id;

            this.selectNode(node.id);
            return;
        }

        this.deselectAll();
    };

    SimpleWorkflowEditor.prototype.onKeyDown = function (e) {
        if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT')) {
            return;
        }

        var isCtrl = e.ctrlKey || e.metaKey;

        if (isCtrl && e.key === 'z' && !e.shiftKey) {
            e.preventDefault();
            this.undo();
            return;
        }
        if (isCtrl && (e.key === 'y' || (e.key === 'z' && e.shiftKey))) {
            e.preventDefault();
            this.redo();
            return;
        }
        if ((e.key === 'Delete' || e.key === 'Backspace') && this.selectedNodeId) {
            var selNode = this.getNodeById(this.selectedNodeId);
            if (selNode && selNode.type !== 'placeholder' && selNode.type !== 'trigger') {
                e.preventDefault();
                if (typeof this.onDeleteRequest === 'function') {
                    this.onDeleteRequest(this.selectedNodeId);
                } else {
                    this.deleteNode(this.selectedNodeId);
                }
            }
        }
    };

    SimpleWorkflowEditor.prototype.onWheel = function (e) {
        e.preventDefault();
        var delta = e.deltaY > 0 ? -0.05 : 0.05;
        var newZoom = clamp(this.zoom + delta, this.minZoom, this.maxZoom);

        var rect = this.canvas.getBoundingClientRect();
        var mx = e.clientX - rect.left;
        var my = e.clientY - rect.top;

        var ratio = newZoom / this.zoom;
        this.panX = mx - ratio * (mx - this.panX);
        this.panY = my - ratio * (my - this.panY);
        this.zoom = newZoom;
    };

    SimpleWorkflowEditor.prototype.onMinimapClick = function (e) {
        if (!this._minimapScale) return;

        var rect = this.minimapCanvas.getBoundingClientRect();
        var mx = (e.clientX - rect.left);
        var my = (e.clientY - rect.top);

        var canvasX = (mx - this._minimapOffX) / this._minimapScale;
        var canvasY = (my - this._minimapOffY) / this._minimapScale;

        var viewW = this.canvas.width / (this.dpr * this.zoom);
        var viewH = this.canvas.height / (this.dpr * this.zoom);

        this.panX = -(canvasX - viewW / 2) * this.zoom;
        this.panY = -(canvasY - viewH / 2) * this.zoom;
    };

    // =========================================================================
    // Action button handlers
    // =========================================================================

    SimpleWorkflowEditor.prototype.handleActionButton = function (action, nodeId) {
        var node = this.getNodeById(nodeId);
        if (!node) return;

        switch (action) {
            case 'configure':
                this.onNodeDoubleClick(node);
                break;
            case 'clone':
                this.cloneNode(nodeId);
                break;
            case 'delete':
                if (node.type !== 'trigger') {
                    if (typeof this.onDeleteRequest === 'function') {
                        this.onDeleteRequest(nodeId);
                    } else {
                        this.deleteNode(nodeId);
                    }
                }
                break;
        }
    };

    // =========================================================================
    // Node operations
    // =========================================================================

    SimpleWorkflowEditor.prototype.addNode = function (type, subType, label, data) {
        this.pushHistory();

        var newNode = {
            id: generateId(),
            type: type,
            label: label || '',
            data: data || {},
            x: 50,
            y: 50
        };

        if (type === 'action') {
            newNode.data.action_type = subType;

            var waMsg = 'Salam {participant_name},\n\nTerima kasih atas sumbangan anda sebanyak RM{amount} untuk program {campaign_name}.\n\nResit rasmi akan dihantar ke emel anda.\n\nSekian, terima kasih.';
            var smsMsg = 'Salam {participant_name}, terima kasih atas sumbangan RM{amount} untuk {campaign_name}. Resit akan dihantar ke emel anda.';
            var emailBody = '<p>Salam {participant_name},</p><p>Terima kasih atas sumbangan anda sebanyak <strong>RM{amount}</strong> untuk program <strong>{campaign_name}</strong>.</p><p>Sila rujuk resit rasmi yang dilampirkan.</p><p>Sekian, terima kasih.</p>';

            var defaults = {
                'send_email': { email_to: '{participant_email}', email_subject: 'Resit Sumbangan {campaign_name}', email_body: emailBody },
                'send_whatsapp': { whatsapp_to: '{participant_tel_no}', whatsapp_message: waMsg },
                'send_wabot': { wabot_to: '{participant_tel_no}', wabot_message: waMsg },
                'send_wasapbot': { wasapbot_to: '{participant_tel_no}', wasapbot_message: waMsg },
                'add_to_smsniaga': { sms_sub_action: 'send_sms', sms_to: '{participant_tel_no}', sms_message: smsMsg },
                'add_to_mailniaga': { mailniaga_version: 'v2', mailniaga_email: '{participant_email}', mailniaga_name: '{participant_name}' },
                'add_to_googlesheets': { sheets_sub_action: 'append_row' },
                'webhook': { webhook_method: 'POST' }
            };
            var d = defaults[subType];
            if (d) {
                for (var k in d) {
                    if (d.hasOwnProperty(k) && !newNode.data[k]) newNode.data[k] = d[k];
                }
            }
        } else if (type === 'trigger') {
            newNode.data.trigger_type = subType;
        } else if (type === 'condition') {
            newNode.data.conditions = newNode.data.conditions || [];
        } else if (type === 'delay') {
            newNode.data.delay_type = newNode.data.delay_type || 'period';
        }

        var lastNode = this.getLastChainNode();
        if (lastNode) {
            newNode.x = lastNode.x + 300;
            newNode.y = lastNode.y;
        }

        // Replace placeholder if the first node is a placeholder and we're adding a trigger
        if (type === 'trigger' && this.nodes.length > 0 && this.nodes[0].type === 'placeholder') {
            var placeholder = this.nodes[0];
            newNode.x = placeholder.x;
            newNode.y = placeholder.y;
            this.nodes[0] = newNode;
        } else {
            this.nodes.push(newNode);

            if (lastNode) {
                var alreadyConnected = this.connections.some(function (c) {
                    return c.from === lastNode.id && c.to === newNode.id;
                });
                if (!alreadyConnected) {
                    this.connections.push({ from: lastNode.id, to: newNode.id });
                }
            }
        }

        this.selectNode(newNode.id);
        this.saveImmediate();
        return newNode;
    };

    SimpleWorkflowEditor.prototype.cloneNode = function (nodeId) {
        var node = this.getNodeById(nodeId);
        if (!node || node.type === 'trigger' || node.type === 'placeholder') return null;

        this.pushHistory();

        var cloned = deepClone(node);
        cloned.id = generateId();
        cloned.x = node.x + 50;
        cloned.y = node.y + 50;
        cloned.label = node.label + ' (copy)';

        var incomingConns = this.connections.filter(function (c) { return c.to === nodeId; });
        var outgoingConns = this.connections.filter(function (c) { return c.from === nodeId; });

        this.nodes.push(cloned);

        // Re-link: insert cloned after original in the chain
        if (outgoingConns.length > 0) {
            for (var i = 0; i < outgoingConns.length; i++) {
                var nextId = outgoingConns[i].to;
                this.connections = this.connections.filter(function (c) {
                    return !(c.from === nodeId && c.to === nextId);
                });
                this.connections.push({ from: nodeId, to: cloned.id });
                this.connections.push({ from: cloned.id, to: nextId });
            }
        } else {
            this.connections.push({ from: nodeId, to: cloned.id });
        }

        this.selectNode(cloned.id);
        this.saveImmediate();
        return cloned;
    };

    SimpleWorkflowEditor.prototype.deleteNode = function (nodeId) {
        var node = this.getNodeById(nodeId);
        if (!node || node.type === 'trigger' || node.type === 'placeholder') return;

        this.pushHistory();

        var incoming = this.connections.filter(function (c) { return c.to === nodeId; });
        var outgoing = this.connections.filter(function (c) { return c.from === nodeId; });

        this.connections = this.connections.filter(function (c) {
            return c.from !== nodeId && c.to !== nodeId;
        });

        // Re-link prev → next
        if (incoming.length > 0 && outgoing.length > 0) {
            for (var i = 0; i < incoming.length; i++) {
                for (var j = 0; j < outgoing.length; j++) {
                    this.connections.push({ from: incoming[i].from, to: outgoing[j].to });
                }
            }
        }

        this.nodes = this.nodes.filter(function (n) { return n.id !== nodeId; });

        if (this.selectedNodeId === nodeId) {
            this.selectedNodeId = null;
            this._actionButtons = [];
        }

        this.saveImmediate();
    };

    SimpleWorkflowEditor.prototype.updateNode = function (nodeId, updates) {
        var node = this.getNodeById(nodeId);
        if (!node) return;

        this.pushHistory();

        if (updates.label !== undefined) node.label = updates.label;
        if (updates.data !== undefined) {
            for (var key in updates.data) {
                if (updates.data.hasOwnProperty(key)) {
                    node.data[key] = updates.data[key];
                }
            }
        }

        this.save();
    };

    SimpleWorkflowEditor.prototype.selectNode = function (nodeId) {
        this.selectedNodeId = nodeId;
        this._actionButtons = [];
    };

    SimpleWorkflowEditor.prototype.deselectAll = function () {
        this.selectedNodeId = null;
        this.lastClickNodeId = null;
        this._actionButtons = [];
    };

    // =========================================================================
    // Load / Save
    // =========================================================================

    SimpleWorkflowEditor.prototype.loadWorkflow = function (data) {
        if (!data || !(data.nodes && data.nodes.length)) {
            this.nodes = [{
                id: generateId(),
                type: 'placeholder',
                label: 'Select an Event',
                data: {},
                x: 50, y: 50
            }];
            this.connections = [];
        } else {
            this.nodes = (data.nodes || []).map(function (n) {
                return {
                    id: n.id || generateId(),
                    type: n.type || 'action',
                    label: n.label || '',
                    data: n.data || {},
                    x: n.x || 0,
                    y: n.y || 0
                };
            });
            this.connections = (data.connections || []).map(function (c) {
                return { from: c.from, to: c.to };
            });
        }

        this.selectedNodeId = null;
        this._actionButtons = [];
        this.history = [];
        this.historyIndex = -1;
        this.pushHistory();
        this.autoFitView();
    };

    SimpleWorkflowEditor.prototype.save = function () {
        var self = this;
        if (this.saveTimer) clearTimeout(this.saveTimer);
        this.saveTimer = setTimeout(function () {
            self.saveImmediate();
        }, this.saveDelay);
    };

    SimpleWorkflowEditor.prototype.saveImmediate = function () {
        if (this.saveTimer) {
            clearTimeout(this.saveTimer);
            this.saveTimer = null;
        }
        var data = this.getWorkflowData();
        this.onSave(data);
    };

    SimpleWorkflowEditor.prototype.getWorkflowData = function () {
        var nodes = this.nodes
            .filter(function (n) { return n.type !== 'placeholder'; })
            .map(function (n) {
                return {
                    id: n.id,
                    type: n.type,
                    label: n.label,
                    data: deepClone(n.data),
                    x: Math.round(n.x),
                    y: Math.round(n.y)
                };
            });

        var connections = this.connections.map(function (c) {
            return { from: c.from, to: c.to };
        });

        return { nodes: nodes, connections: connections };
    };

    // =========================================================================
    // Undo / Redo
    // =========================================================================

    SimpleWorkflowEditor.prototype.pushHistory = function () {
        var state = {
            nodes: deepClone(this.nodes),
            connections: deepClone(this.connections)
        };

        if (this.historyIndex < this.history.length - 1) {
            this.history = this.history.slice(0, this.historyIndex + 1);
        }

        this.history.push(state);

        if (this.history.length > this.maxHistory) {
            this.history.shift();
        }

        this.historyIndex = this.history.length - 1;
    };

    SimpleWorkflowEditor.prototype.undo = function () {
        if (this.historyIndex <= 0) return;

        this.historyIndex--;
        var state = this.history[this.historyIndex];
        this.nodes = deepClone(state.nodes);
        this.connections = deepClone(state.connections);
        this.selectedNodeId = null;
        this._actionButtons = [];
        this.saveImmediate();
    };

    SimpleWorkflowEditor.prototype.redo = function () {
        if (this.historyIndex >= this.history.length - 1) return;

        this.historyIndex++;
        var state = this.history[this.historyIndex];
        this.nodes = deepClone(state.nodes);
        this.connections = deepClone(state.connections);
        this.selectedNodeId = null;
        this._actionButtons = [];
        this.saveImmediate();
    };

    // =========================================================================
    // Zoom
    // =========================================================================

    SimpleWorkflowEditor.prototype.setZoom = function (level) {
        this.zoom = clamp(level, this.minZoom, this.maxZoom);
    };

    SimpleWorkflowEditor.prototype.zoomIn = function () {
        this.setZoom(this.zoom + 0.1);
    };

    SimpleWorkflowEditor.prototype.zoomOut = function () {
        this.setZoom(this.zoom - 0.1);
    };

    SimpleWorkflowEditor.prototype.resetZoom = function () {
        this.zoom = 1.0;
        this.panX = 0;
        this.panY = 0;
    };

    SimpleWorkflowEditor.prototype.autoFitView = function () {
        if (this.nodes.length === 0) return;

        var bounds = this.getNodesBounds();
        var padding = 60;
        var bw = bounds.maxX - bounds.minX + NODE_W + padding * 2;
        var bh = bounds.maxY - bounds.minY + NODE_H + padding * 2;

        var canvasW = this.canvas.width / this.dpr;
        var canvasH = this.canvas.height / this.dpr;

        var fitZoom = Math.min(canvasW / bw, canvasH / bh, this.maxZoom);
        fitZoom = clamp(fitZoom, this.minZoom, this.maxZoom);

        this.zoom = fitZoom;
        this.panX = (canvasW - bw * fitZoom) / 2 - bounds.minX * fitZoom + padding * fitZoom;
        this.panY = (canvasH - bh * fitZoom) / 2 - bounds.minY * fitZoom + padding * fitZoom;
    };

    // =========================================================================
    // Hit testing
    // =========================================================================

    SimpleWorkflowEditor.prototype.getNodeAtPoint = function (x, y) {
        for (var i = this.nodes.length - 1; i >= 0; i--) {
            var n = this.nodes[i];
            if (x >= n.x && x <= n.x + NODE_W && y >= n.y && y <= n.y + NODE_H) {
                return n;
            }
        }
        return null;
    };

    SimpleWorkflowEditor.prototype.getPortAtPoint = function (x, y, type) {
        for (var i = 0; i < this.nodes.length; i++) {
            var n = this.nodes[i];
            if (n.type === 'placeholder') continue;

            if (type === 'output') {
                var ox = n.x + NODE_W;
                var oy = n.y + NODE_H / 2;
                if (Math.sqrt((x - ox) * (x - ox) + (y - oy) * (y - oy)) <= PORT_HIT_R) {
                    return n;
                }
            } else if (type === 'input') {
                var isFirst = (this.nodes.indexOf(n) === 0);
                if (isFirst) continue;
                var ix = n.x;
                var iy = n.y + NODE_H / 2;
                if (Math.sqrt((x - ix) * (x - ix) + (y - iy) * (y - iy)) <= PORT_HIT_R) {
                    return n;
                }
            }
        }
        return null;
    };

    SimpleWorkflowEditor.prototype.getConnectionAtPoint = function (x, y) {
        var threshold = 8;

        for (var i = 0; i < this.connections.length; i++) {
            var conn = this.connections[i];
            var fromNode = this.getNodeById(conn.from);
            var toNode = this.getNodeById(conn.to);
            if (!fromNode || !toNode) continue;

            var x1 = fromNode.x + NODE_W;
            var y1 = fromNode.y + NODE_H / 2;
            var x2 = toNode.x;
            var y2 = toNode.y + NODE_H / 2;
            var cpOffset = Math.min(Math.abs(x2 - x1) * 0.5, 150);
            var cp1x = x1 + cpOffset;
            var cp1y = y1;
            var cp2x = x2 - cpOffset;
            var cp2y = y2;

            for (var t = 0; t <= 1; t += 0.02) {
                var pt = this.bezierPoint(x1, y1, cp1x, cp1y, cp2x, cp2y, x2, y2, t);
                var dist = Math.sqrt((x - pt.x) * (x - pt.x) + (y - pt.y) * (y - pt.y));
                if (dist <= threshold) return i;
            }
        }

        return -1;
    };

    // =========================================================================
    // Validation
    // =========================================================================

    SimpleWorkflowEditor.prototype.isNodeComplete = function (node) {
        if (!node || !node.data) return true;

        var d = node.data;

        if (node.type === 'trigger') {
            return !!d.trigger_type;
        }

        if (node.type === 'condition') {
            return Array.isArray(d.conditions) && d.conditions.length > 0;
        }

        if (node.type === 'delay') {
            if (d.delay_type === 'datetime') {
                return !!d.delay_until_datetime;
            }
            return !!d.delay_value;
        }

        if (node.type === 'action') {
            switch (d.action_type) {
                case 'send_email':
                    return !!(d.email_to && d.email_subject && d.email_body);
                case 'send_whatsapp':
                    return !!(d.whatsapp_to && d.whatsapp_message);
                case 'send_wabot':
                    return !!(d.wabot_to && d.wabot_message);
                case 'send_wasapbot':
                    return !!(d.wasapbot_to && d.wasapbot_message);
                case 'add_to_mailniaga':
                    return !!(d.mailniaga_email && d.mailniaga_list_id);
                case 'add_to_smsniaga':
                    if (d.sms_action === 'add_subscriber') {
                        return !!(d.group_uuid && d.subscriber_phone);
                    }
                    return !!(d.sms_to && d.sms_message);
                case 'add_to_googlesheets':
                    return !!(d.spreadsheet_id && d.sheet_name);
                case 'webhook':
                    return !!d.webhook_url;
                default:
                    return true;
            }
        }

        return true;
    };

    SimpleWorkflowEditor.prototype.getNodeIncompleteReason = function (node) {
        if (!node || !node.data) return '';

        var d = node.data;

        // Check integration config first
        var unconfiguredMsg = this.getUnconfiguredReason(node);
        if (unconfiguredMsg) return unconfiguredMsg;

        if (node.type === 'trigger') {
            if (!d.trigger_type) return 'No trigger type selected';
            return '';
        }

        if (node.type === 'condition') {
            if (!Array.isArray(d.conditions) || d.conditions.length === 0) {
                return 'No conditions configured';
            }
            return '';
        }

        if (node.type === 'delay') {
            if (d.delay_type === 'datetime' && !d.delay_until_datetime) {
                return 'Delay datetime not set';
            }
            if (d.delay_type !== 'datetime' && !d.delay_value) {
                return 'Delay value not set';
            }
            return '';
        }

        if (node.type === 'action') {
            var missing = [];
            switch (d.action_type) {
                case 'send_email':
                    if (!d.email_to) missing.push('recipient');
                    if (!d.email_subject) missing.push('subject');
                    if (!d.email_body) missing.push('body');
                    break;
                case 'send_whatsapp':
                    if (!d.whatsapp_to) missing.push('recipient');
                    if (!d.whatsapp_message) missing.push('message');
                    break;
                case 'send_wabot':
                    if (!d.wabot_to) missing.push('recipient');
                    if (!d.wabot_message) missing.push('message');
                    break;
                case 'send_wasapbot':
                    if (!d.wasapbot_to) missing.push('recipient');
                    if (!d.wasapbot_message) missing.push('message');
                    break;
                case 'add_to_mailniaga':
                    if (!d.mailniaga_email) missing.push('email');
                    if (!d.mailniaga_list_id) missing.push('list');
                    break;
                case 'add_to_smsniaga':
                    if (d.sms_action === 'add_subscriber') {
                        if (!d.group_uuid) missing.push('group');
                        if (!d.subscriber_phone) missing.push('phone');
                    } else {
                        if (!d.sms_to) missing.push('recipient');
                        if (!d.sms_message) missing.push('message');
                    }
                    break;
                case 'add_to_googlesheets':
                    if (!d.spreadsheet_id) missing.push('spreadsheet');
                    if (!d.sheet_name) missing.push('sheet name');
                    break;
                case 'webhook':
                    if (!d.webhook_url) missing.push('URL');
                    break;
            }
            if (missing.length > 0) return 'Missing: ' + missing.join(', ');
        }

        return '';
    };

    SimpleWorkflowEditor.prototype.isNodeUnconfigured = function (node) {
        return !!this.getUnconfiguredReason(node);
    };

    SimpleWorkflowEditor.prototype.getUnconfiguredReason = function (node) {
        if (!node || !node.data || node.type !== 'action') return '';
        var config = window.integrationConfig || {};
        var actionType = node.data.action_type || '';
        var map = {
            'send_whatsapp': ['wasapbom', 'WasapBom'],
            'send_wabot': ['wabot', 'Wabot'],
            'send_wasapbot': ['wasapbot', 'WasapBot'],
            'add_to_smsniaga': ['smsniaga', 'SMS Niaga'],
            'add_to_googlesheets': ['googlesheets', 'Google Sheets'],
        };

        var key, label;
        if (actionType === 'add_to_mailniaga') {
            var ver = node.data.mailniaga_version || 'v2';
            key = ver === 'v1' ? 'mailniaga_v1' : 'mailniaga_v2';
            label = 'Mail Niaga ' + ver.toUpperCase();
        } else {
            var entry = map[actionType];
            if (!entry) return '';
            key = entry[0];
            label = entry[1];
        }

        var info = config[key];
        if (!info) return label + ' not configured';

        if (!info.enabled && !info.configured) return label + ' is disabled and not configured';
        if (!info.enabled) return label + ' is disabled';
        if (!info.configured) return label + ' credentials not configured';
        return '';
    };

    // =========================================================================
    // Coordinate transforms
    // =========================================================================

    SimpleWorkflowEditor.prototype.screenToCanvas = function (screenX, screenY) {
        return {
            x: (screenX - this.panX) / this.zoom,
            y: (screenY - this.panY) / this.zoom
        };
    };

    SimpleWorkflowEditor.prototype.canvasToScreen = function (canvasX, canvasY) {
        return {
            x: canvasX * this.zoom + this.panX,
            y: canvasY * this.zoom + this.panY
        };
    };

    // =========================================================================
    // Utility: node lookup, colors, bezier math, text truncation
    // =========================================================================

    SimpleWorkflowEditor.prototype.getNodeById = function (id) {
        for (var i = 0; i < this.nodes.length; i++) {
            if (this.nodes[i].id === id) return this.nodes[i];
        }
        return null;
    };

    SimpleWorkflowEditor.prototype.getLastChainNode = function () {
        if (this.nodes.length === 0) return null;

        var nodesWithOutgoing = {};
        for (var i = 0; i < this.connections.length; i++) {
            nodesWithOutgoing[this.connections[i].from] = true;
        }

        for (var j = this.nodes.length - 1; j >= 0; j--) {
            if (!nodesWithOutgoing[this.nodes[j].id]) {
                return this.nodes[j];
            }
        }

        return this.nodes[this.nodes.length - 1];
    };

    SimpleWorkflowEditor.prototype.getNodeColors = function (node) {
        if (node.type === 'trigger') {
            var trigType = (node.data && node.data.trigger_type) || '';
            return TRIGGER_COLORS[trigType] || { iconColor: '#6b7280', bgColor: '#f3f4f6' };
        }
        if (node.type === 'action') {
            var actType = (node.data && node.data.action_type) || '';
            return ACTION_COLORS[actType] || { iconColor: '#6b7280', bgColor: '#f3f4f6' };
        }
        if (node.type === 'condition') return CONDITION_COLORS;
        if (node.type === 'delay') return DELAY_COLORS;
        return { iconColor: '#6b7280', bgColor: '#f3f4f6' };
    };

    SimpleWorkflowEditor.prototype.getNodesBounds = function () {
        var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        for (var i = 0; i < this.nodes.length; i++) {
            var n = this.nodes[i];
            if (n.x < minX) minX = n.x;
            if (n.y < minY) minY = n.y;
            if (n.x > maxX) maxX = n.x;
            if (n.y > maxY) maxY = n.y;
        }
        return { minX: minX, minY: minY, maxX: maxX, maxY: maxY };
    };

    SimpleWorkflowEditor.prototype.bezierPoint = function (x1, y1, cp1x, cp1y, cp2x, cp2y, x2, y2, t) {
        var mt = 1 - t;
        var mt2 = mt * mt;
        var mt3 = mt2 * mt;
        var t2 = t * t;
        var t3 = t2 * t;
        return {
            x: mt3 * x1 + 3 * mt2 * t * cp1x + 3 * mt * t2 * cp2x + t3 * x2,
            y: mt3 * y1 + 3 * mt2 * t * cp1y + 3 * mt * t2 * cp2y + t3 * y2
        };
    };

    SimpleWorkflowEditor.prototype.bezierTangent = function (x1, y1, cp1x, cp1y, cp2x, cp2y, x2, y2, t) {
        var mt = 1 - t;
        var mt2 = mt * mt;
        var t2 = t * t;
        return {
            x: 3 * mt2 * (cp1x - x1) + 6 * mt * t * (cp2x - cp1x) + 3 * t2 * (x2 - cp2x),
            y: 3 * mt2 * (cp1y - y1) + 6 * mt * t * (cp2y - cp1y) + 3 * t2 * (y2 - cp2y)
        };
    };

    SimpleWorkflowEditor.prototype.roundRect = function (ctx, x, y, w, h, r) {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.lineTo(x + w - r, y);
        ctx.arcTo(x + w, y, x + w, y + r, r);
        ctx.lineTo(x + w, y + h - r);
        ctx.arcTo(x + w, y + h, x + w - r, y + h, r);
        ctx.lineTo(x + r, y + h);
        ctx.arcTo(x, y + h, x, y + h - r, r);
        ctx.lineTo(x, y + r);
        ctx.arcTo(x, y, x + r, y, r);
        ctx.closePath();
    };

    SimpleWorkflowEditor.prototype.truncateText = function (ctx, text, maxWidth) {
        if (ctx.measureText(text).width <= maxWidth) return text;
        var ellipsis = '...';
        var eW = ctx.measureText(ellipsis).width;
        var len = text.length;
        while (len > 0 && ctx.measureText(text.substring(0, len)).width + eW > maxWidth) {
            len--;
        }
        return text.substring(0, len) + ellipsis;
    };

    // =========================================================================
    // Bulk operations for external use
    // =========================================================================

    SimpleWorkflowEditor.prototype.setTrigger = function (triggerType, label, data) {
        var triggerNode = null;
        for (var i = 0; i < this.nodes.length; i++) {
            if (this.nodes[i].type === 'trigger' || this.nodes[i].type === 'placeholder') {
                triggerNode = this.nodes[i];
                break;
            }
        }

        if (!triggerNode) return null;

        this.pushHistory();

        triggerNode.type = 'trigger';
        triggerNode.label = label || this.formatTriggerLabel(triggerType);
        triggerNode.data = data || {};
        triggerNode.data.trigger_type = triggerType;

        this.selectNode(triggerNode.id);
        this.saveImmediate();
        return triggerNode;
    };

    SimpleWorkflowEditor.prototype.formatTriggerLabel = function (triggerType) {
        return (triggerType || '')
            .split('_')
            .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); })
            .join(' ');
    };

    SimpleWorkflowEditor.prototype.getSelectedNode = function () {
        if (!this.selectedNodeId) return null;
        return this.getNodeById(this.selectedNodeId);
    };

    SimpleWorkflowEditor.prototype.getNodeCount = function () {
        return this.nodes.filter(function (n) { return n.type !== 'placeholder'; }).length;
    };

    SimpleWorkflowEditor.prototype.getTriggerNode = function () {
        for (var i = 0; i < this.nodes.length; i++) {
            if (this.nodes[i].type === 'trigger') return this.nodes[i];
        }
        return null;
    };

    SimpleWorkflowEditor.prototype.getAllNodes = function () {
        return this.nodes.filter(function (n) { return n.type !== 'placeholder'; });
    };

    SimpleWorkflowEditor.prototype.getIncompleteNodes = function () {
        var self = this;
        return this.nodes.filter(function (n) {
            return n.type !== 'placeholder' && !self.isNodeComplete(n);
        });
    };

    SimpleWorkflowEditor.prototype.isWorkflowValid = function () {
        var realNodes = this.getAllNodes();
        if (realNodes.length === 0) return false;

        var hasTrigger = realNodes.some(function (n) { return n.type === 'trigger'; });
        if (!hasTrigger) return false;

        var self = this;
        var allComplete = realNodes.every(function (n) { return self.isNodeComplete(n); });
        return allComplete;
    };

    SimpleWorkflowEditor.prototype.clearWorkflow = function () {
        this.pushHistory();
        this.nodes = [{
            id: generateId(),
            type: 'placeholder',
            label: 'Select an Event',
            data: {},
            x: 50, y: 50
        }];
        this.connections = [];
        this.selectedNodeId = null;
        this._actionButtons = [];
        this.saveImmediate();
    };

    SimpleWorkflowEditor.prototype.scrollToNode = function (nodeId) {
        var node = this.getNodeById(nodeId);
        if (!node) return;

        var canvasW = this.canvas.width / this.dpr;
        var canvasH = this.canvas.height / this.dpr;
        var cx = node.x + NODE_W / 2;
        var cy = node.y + NODE_H / 2;

        this.panX = canvasW / 2 - cx * this.zoom;
        this.panY = canvasH / 2 - cy * this.zoom;
    };

    SimpleWorkflowEditor.prototype.highlightNode = function (nodeId) {
        this.selectNode(nodeId);
        this.scrollToNode(nodeId);
    };

    // =========================================================================
    // Export as JSON string
    // =========================================================================

    SimpleWorkflowEditor.prototype.exportJSON = function () {
        return JSON.stringify(this.getWorkflowData(), null, 2);
    };

    SimpleWorkflowEditor.prototype.importJSON = function (json) {
        try {
            var data = typeof json === 'string' ? JSON.parse(json) : json;
            this.loadWorkflow(data);
        } catch (e) {
            console.error('SimpleWorkflowEditor: Invalid JSON import', e);
        }
    };

    // =========================================================================
    // Canvas export
    // =========================================================================

    SimpleWorkflowEditor.prototype.toDataURL = function (type, quality) {
        return this.canvas.toDataURL(type || 'image/png', quality || 1.0);
    };

    // Convenience aliases used by edit blade
    SimpleWorkflowEditor.prototype.setTriggerNode = function (triggerType, label) {
        return this.setTrigger(triggerType, label);
    };

    SimpleWorkflowEditor.prototype.updateNodeData = function (nodeId, data) {
        this.updateNode(nodeId, { data: data });
    };

    SimpleWorkflowEditor.prototype.canUndo = function () {
        return this.historyIndex > 0;
    };

    SimpleWorkflowEditor.prototype.canRedo = function () {
        return this.historyIndex < this.history.length - 1;
    };

    window.SimpleWorkflowEditor = SimpleWorkflowEditor;

})();
